/**
 * Wave 14 Agent TRIAL - Layer 3.
 *
 * Day 14+ hard lock that takes over the viewport once the trial ends.
 * Shows the convert-to-pilot CTA and the credit story (AED 4,250 fee
 * refunds 100% within the 30-day window).
 */
import { useTrialStatus } from '@/hooks/useTrialStatus'

export function TrialEndLockScreen() {
  const { status, loading } = useTrialStatus()

  if (loading || !status) return null
  if (status.in_trial) return null

  return (
    <div
      data-testid="trial-end-lock-screen"
      className="fixed inset-0 z-50 bg-slate-900/90 flex items-center justify-center"
    >
      <div className="bg-white rounded-xl shadow-2xl max-w-xl w-full mx-4 p-8 text-center">
        <div className="text-3xl mb-2">Your trial has ended</div>
        <p className="text-slate-600">
          Pick up where you left off. Two paths from here:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          <a
            href="/pilot/apply"
            className="rounded-lg border border-blue-500 p-4 hover:bg-blue-50 text-start"
          >
            <div className="font-semibold">Start a 30-day paid pilot</div>
            <p className="text-sm text-slate-600 mt-1">
              AED 4,250 one-off. Full refund within 30 days. Successful
              pilots apply the AED 4,250 as credit on your annual plan.
            </p>
          </a>
          <a
            href="/billing"
            className="rounded-lg border border-slate-300 p-4 hover:bg-slate-50 text-start"
          >
            <div className="font-semibold">Subscribe to annual</div>
            <p className="text-sm text-slate-600 mt-1">
              Skip the pilot and go straight to a yearly plan.
            </p>
          </a>
        </div>
        <p className="text-xs text-slate-500 mt-6">
          Need more time? Email us at sales@orkstra.com.
        </p>
      </div>
    </div>
  )
}

export default TrialEndLockScreen
